import {GetDoc, GetDocs, CreateAccessor} from "mobx-graphlink";
import {RecordingSession} from "./recordingSessions/@RecordingSession";

export const GetRecordingSessions = CreateAccessor((): RecordingSession[]=>{
	return GetDocs({}, a=>a.recordingSessions);
});
export const GetRecordingSession = CreateAccessor((id: string|n): RecordingSession|n=>{
	return GetDoc({}, a=>a.recordingSessions.get(id!));
});